/* eslint-disable react/no-multi-comp */
import React from 'react';
import { palette } from '../../styles/theme';

export function RecycleBinSVG ({ customStroke, width = 28, height = 24 }) {
    const stroke = customStroke || '#B71E15';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <g clipPath="url(#clip0_6108_15179)">
                <path d="M4 7H20" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10 11V17" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14 11V17" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 7V4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V7" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6108_15179">
                    <rect width="28" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export function RecycleBinDeleteSVG ({ customStroke = palette.secondary[600] }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clipPath="url(#clip0_6225_10570)">
                <path d="M5.33334 9.33301H26.6667" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.3333 14.667V22.667" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18.6667 14.667V22.667" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.66666 9.33301L8 25.333C8 26.0403 8.28095 26.7185 8.78105 27.2186C9.28114 27.7187 9.95942 27.9997 10.6667 27.9997H21.3333C22.0406 27.9997 22.7189 27.7187 23.2189 27.2186C23.719 26.7185 24 26.0403 24 25.333L25.3333 9.33301" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 9.33333V5.33333C12 4.97971 12.1405 4.64057 12.3905 4.39052C12.6406 4.14048 12.9797 4 13.3333 4H18.6667C19.0203 4 19.3594 4.14048 19.6095 4.39052C19.8595 4.64057 20 4.97971 20 5.33333V9.33333" stroke={customStroke} strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6225_10570">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
